module.exports = __webpack_public_path__ + "img/inter29.47106d0c.jpg";